import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f37ae7c")

_pushScopeId("data-v-3f37ae7c")
const _hoisted_1 = { class: "carInfo" }
const _hoisted_2 = {
  key: 0,
  class: "carInfo_card"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "titleSlot" }, "*车型信息仅供参考，请以实车为准", -1)
const _hoisted_4 = { class: "infoList infoList_2col" }
const _hoisted_5 = {
  key: 0,
  class: "infoListItem infoListItem_full"
}
const _hoisted_6 = { class: "infoListItem_name w144" }
const _hoisted_7 = { class: "infoListItem_value" }
const _hoisted_8 = { class: "infoListItem_name w144" }
const _hoisted_9 = { class: "infoListItem_value" }
const _hoisted_10 = {
  key: 1,
  class: "carInfo_card"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "titleSlot" }, "*配置信息仅供参考，请以实车为准", -1)
const _hoisted_12 = { class: "infoList infoList_2col" }
const _hoisted_13 = { class: "infoListItem_name w144" }
const _hoisted_14 = { class: "infoListItem_value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_componentTitle = _resolveComponent("componentTitle")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.baseInfo && _ctx.state.baseInfo.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_componentTitle, { title: "车辆信息" }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode("ul", _hoisted_4, [
            (_ctx.vinItem)
              ? (_openBlock(), _createBlock("li", _hoisted_5, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.vinItem.name), 1),
                  _createVNode("span", _hoisted_7, _toDisplayString(_ctx.vinItem.value || '--'), 1)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.baseInfoRest, (item) => {
              return (_openBlock(), _createBlock("li", {
                class: "infoListItem",
                key: item.code
              }, [
                _createVNode("span", _hoisted_8, _toDisplayString(item.name), 1),
                _createVNode("span", _hoisted_9, _toDisplayString(item.value || '--'), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.configInfo && _ctx.state.configInfo.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode(_component_componentTitle, { title: "配置信息" }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode("ul", _hoisted_12, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.configInfo, (item) => {
              return (_openBlock(), _createBlock("li", {
                class: "infoListItem",
                key: item.code
              }, [
                _createVNode("span", _hoisted_13, _toDisplayString(item.name), 1),
                _createVNode("span", _hoisted_14, _toDisplayString(item.value || '--'), 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})